var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-c3',{staticStyle:{"height":"100%"},attrs:{"id":_vm.componentId,"handler":_vm.handler}})
}
var staticRenderFns = []

export { render, staticRenderFns }